import { convertHexToRgbA } from '../utils';

const COLOR_SCHEME = {
	PRIMARY: 'primary',
	SECONDARY: 'secondary',
	LIGHT: 'light',
	DARK: 'dark',
	NEUTRAL: 'neutral',
	GHOST: 'ghost'
};

export const COLOR_SCHEME_STATES = {
	[COLOR_SCHEME.PRIMARY]: {
		normal: {
			backgroundColor: '#c7e914'
		},
		hover: {
			backgroundColor: '#a9c709'
		},
		active: {
			backgroundColor: '#C7E914'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#C7E914', 0.15)
		}
	},
	[COLOR_SCHEME.LIGHT]: {
		normal: {
			backgroundColor: '#ffffff'
		},
		hover: {
			backgroundColor: '#E5E5E5'
		},
		active: {
			backgroundColor: '#D9D9D9'
		},
		disabled: {
			backgroundColor: convertHexToRgbA('#ffffff', 0.1)
		}
	},
	[COLOR_SCHEME.DARK]: {
		normal: {
			backgroundColor: '#164859'
		},
		hover: {
			backgroundColor: '#1A586D'
		},
		active: {
			backgroundColor: '#154656'
		},
		disabled: {
			backgroundColor: '#74736F'
		}
	},
	[COLOR_SCHEME.NEUTRAL]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	},
	[COLOR_SCHEME.GHOST]: {
		normal: {
			backgroundColor: 'transparent'
		},
		hover: {
			backgroundColor: 'transparent'
		},
		active: {
			backgroundColor: 'transparent'
		},
		disabled: {
			backgroundColor: 'transparent'
		}
	}
};
